<template>
  <img src="@/assets/img/Icons/Oil.svg" />
</template>

<script>
export default {}
</script>

<style></style>
